"use client";

import { c as _c } from "react/compiler-runtime";
import { useActionState, useEffect } from "react";
import InputComponent from "@/components/ui/InputComponent";
import { useTranslations } from "next-intl";
import { verify2FA } from "../actions";
import ModalComponent from "@/components/modals/ModalComponent";
import { toast } from "sonner";
import { fetchResendOTP } from "../api";
const INITIAL_STATE: string | undefined = undefined;
export interface TwoFactorCodeModalProps {
  isValidationModalOpen: boolean;
  setIsValidationModalOpen: (_isOpen: boolean) => void;
}
export function TwoFactorCodeModal(t0) {
  const $ = _c(44);
  const {
    isValidationModalOpen,
    setIsValidationModalOpen
  } = t0;
  const [error, formAction, isPending] = useActionState(verify2FA, INITIAL_STATE);
  const labels = useTranslations("Labels");
  const modals = useTranslations("Modals");
  const placeholders = useTranslations("Placeholders");
  const handleResendCode = _temp;
  let t1;
  let t2;
  if ($[0] !== error || $[1] !== isPending) {
    t1 = () => {
      if (!isPending && error) {
        toast.error(error);
      }
    };
    t2 = [isPending, error];
    $[0] = error;
    $[1] = isPending;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== labels) {
    t3 = labels("labelVerificationText");
    $[4] = labels;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== setIsValidationModalOpen) {
    t4 = () => setIsValidationModalOpen(false);
    $[6] = setIsValidationModalOpen;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== labels) {
    t5 = labels("labelVerificationDescription");
    $[8] = labels;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <p>{t5}</p>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== labels) {
    t7 = labels("labelVerificationCode");
    $[12] = labels;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== placeholders) {
    t8 = placeholders("placeholderVerificationCode");
    $[14] = placeholders;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== error || $[17] !== t7 || $[18] !== t8) {
    t9 = <InputComponent id="code" name="code" type="text" label={t7} placeholder={t8} isRequired={true} autoComplete="one-time-code" className="input--full" maxLength={6} error={error} />;
    $[16] = error;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      marginTop: "16px",
      marginBottom: "-10px"
    };
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== modals) {
    t11 = modals("requiredFieldsMessage");
    $[21] = modals;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <p className="modal__required-fields-message" style={t10}>{t11}</p>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      fontSize: "14px",
      lineHeight: "16px"
    };
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== labels) {
    t14 = labels("labelNoCodeReceived");
    $[26] = labels;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== labels) {
    t15 = labels("labelResendCode");
    $[28] = labels;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15) {
    t16 = <button className="auth__link-primary" type="button" onClick={handleResendCode}>{t15}</button>;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t14 || $[33] !== t16) {
    t17 = <p style={t13}>{t14}{t16}</p>;
    $[32] = t14;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== isPending || $[36] !== isValidationModalOpen || $[37] !== t12 || $[38] !== t17 || $[39] !== t3 || $[40] !== t4 || $[41] !== t6 || $[42] !== t9) {
    t18 = <ModalComponent title={t3} isOpen={isValidationModalOpen} onClose={t4} formAction={formAction} hideSubmitIcon={true} buttonSubmitText="buttonVerify" disabledConfirm={isPending} loadingConfirm={isPending} hideRequiredFieldsMessage={true}>{t6}{t9}{t12}{t17}</ModalComponent>;
    $[35] = isPending;
    $[36] = isValidationModalOpen;
    $[37] = t12;
    $[38] = t17;
    $[39] = t3;
    $[40] = t4;
    $[41] = t6;
    $[42] = t9;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}
async function _temp() {
  const response = await fetchResendOTP();
  if (response.error) {
    toast.error(response.message);
    return;
  }
  toast.success(response.message);
}